import { useEffect, useState } from "react";
import DestinationCard from "@/components/DestinationCard";
import Seo from "@/components/Seo";
import { listDestinations } from "@/lib/api";

const DESTINATIONS_BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Destinations", path: "/destinations" },
];

export default function DestinationsIndex() {
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    listDestinations().then(setDestinations).catch(() => {});
    // listDestinations is a stable module-level helper; setDestinations is a stable setter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-32" data-testid="destinations-index">
      <Seo
        path="/destinations"
        title="Destinations — 11 Asian DMC Markets | Trawelldmc"
        description="Explore Trawelldmc's 11 destinations: Dubai, Singapore, Malaysia, Thailand, Hong Kong, Philippines, Vietnam, Cambodia, Bali, Laos, Japan. Each backed by local ground teams and 2 decades of vendor relationships."
        breadcrumb={DESTINATIONS_BREADCRUMB}
      />
      <div className="max-w-3xl mb-16">
        <div className="overline mb-5">Destinations</div>
        <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-[#0B192C]">
          Eleven regions.  
          <br />
          One ground-up operator.
        </h1>
        <p className="text-slate-600 mt-6 text-lg leading-relaxed">
          We operate as a boutique DMC with depth, not breadth. Every destination below is staffed
          with local ops teams, contracted hotel inventory, and two decades of vendor relationships.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {destinations.map((d) => (
          <DestinationCard key={d.slug} destination={d} />
        ))}
      </div>
    </div>
  );
}
